webpackJsonp([114276838955818,60335399758886],{

/***/ 288:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Online Practice","languages":{"langs":[{"slug":"ar","title":"العربية"},{"slug":"zh-Hans","title":"简体中文"},{"slug":"zh-Hant","title":"正體中文"},{"slug":"hr","title":"Hrvatski"},{"slug":"cs","title":"česky"},{"slug":"en","title":"English"},{"slug":"fr","title":"Français"},{"slug":"de","title":"Deutsch"},{"slug":"hu","title":"Magyar"},{"slug":"id","title":"Bahasa Indonesia"},{"slug":"it","title":"Italiano"},{"slug":"ja","title":"日本語"},{"slug":"ko","title":"한국어"},{"slug":"pl","title":"Polski"},{"slug":"pt-BR","title":"Português (BR)"},{"slug":"ru","title":"русский"},{"slug":"sk","title":"Slovenčina"},{"slug":"sl","title":"Slovenščina"},{"slug":"es","title":"Español (España)"},{"slug":"es-419","title":"Español (América Latina)"},{"slug":"th","title":"ภาษาไทย"},{"slug":"tr","title":"Türkçe"},{"slug":"vi","title":"Tiếng Việt"}]}}},"sitePage":{"path":"/dev-404-page/"}},"layoutContext":{}}

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(649);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(288);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(143);
	var isArguments = __webpack_require__(142);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 142:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 143:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {function detect() {
	  var nodeVersion = getNodeVersion();
	  if (nodeVersion) {
	    return nodeVersion;
	  } else if (typeof navigator !== 'undefined') {
	    return parseUserAgent(navigator.userAgent);
	  }
	
	  return null;
	}
	
	function detectOS(userAgentString) {
	  var rules = getOperatingSystemRules();
	  var detected = rules.filter(function (os) {
	    return os.rule && os.rule.test(userAgentString);
	  })[0];
	
	  return detected ? detected.name : null;
	}
	
	function getNodeVersion() {
	  var isNode = typeof navigator === 'undefined' && typeof process !== 'undefined';
	  return isNode ? {
	    name: 'node',
	    version: process.version.slice(1),
	    os: __webpack_require__(1689).type().toLowerCase()
	  } : null;
	}
	
	function parseUserAgent(userAgentString) {
	  var browsers = getBrowserRules();
	  if (!userAgentString) {
	    return null;
	  }
	
	  var detected = browsers.map(function(browser) {
	    var match = browser.rule.exec(userAgentString);
	    var version = match && match[1].split(/[._]/).slice(0,3);
	
	    if (version && version.length < 3) {
	      version = version.concat(version.length == 1 ? [0, 0] : [0]);
	    }
	
	    return match && {
	      name: browser.name,
	      version: version.join('.')
	    };
	  }).filter(Boolean)[0] || null;
	
	  if (detected) {
	    detected.os = detectOS(userAgentString);
	  }
	
	  if (/alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/i.test(userAgentString)) {
	    detected = detected || {};
	    detected.bot = true;
	  }
	  
	  return detected;
	}
	
	function getBrowserRules() {
	  return buildRules([
	    [ 'aol', /AOLShield\/([0-9\._]+)/ ],
	    [ 'edge', /Edge\/([0-9\._]+)/ ],
	    [ 'yandexbrowser', /YaBrowser\/([0-9\._]+)/ ],
	    [ 'vivaldi', /Vivaldi\/([0-9\.]+)/ ],
	    [ 'kakaotalk', /KAKAOTALK\s([0-9\.]+)/ ],
	    [ 'samsung', /SamsungBrowser\/([0-9\.]+)/ ],
	    [ 'chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'crios', /CriOS\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'firefox', /Firefox\/([0-9\.]+)(?:\s|$)/ ],
	    [ 'fxios', /FxiOS\/([0-9\.]+)/ ],
	    [ 'opera', /Opera\/([0-9\.]+)(?:\s|$)/ ],
	    [ 'opera', /OPR\/([0-9\.]+)(:?\s|$)$/ ],
	    [ 'ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/ ],
	    [ 'ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/ ],
	    [ 'ie', /MSIE\s(7\.0)/ ],
	    [ 'bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/ ],
	    [ 'android', /Android\s([0-9\.]+)/ ],
	    [ 'ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/ ],
	    [ 'safari', /Version\/([0-9\._]+).*Safari/ ],
	    [ 'facebook', /FBAV\/([0-9\.]+)/],
	    [ 'instagram', /Instagram\ ([0-9\.]+)/]
	  ]);
	}
	
	function getOperatingSystemRules() {
	  return buildRules([
	    [ 'iOS', /iP(hone|od|ad)/ ],
	    [ 'Android OS', /Android/ ],
	    [ 'BlackBerry OS', /BlackBerry|BB10/ ],
	    [ 'Windows Mobile', /IEMobile/ ],
	    [ 'Amazon OS', /Kindle/ ],
	    [ 'Windows 3.11', /Win16/ ],
	    [ 'Windows 95', /(Windows 95)|(Win95)|(Windows_95)/ ],
	    [ 'Windows 98', /(Windows 98)|(Win98)/ ],
	    [ 'Windows 2000', /(Windows NT 5.0)|(Windows 2000)/ ],
	    [ 'Windows XP', /(Windows NT 5.1)|(Windows XP)/ ],
	    [ 'Windows Server 2003', /(Windows NT 5.2)/ ],
	    [ 'Windows Vista', /(Windows NT 6.0)/ ],
	    [ 'Windows 7', /(Windows NT 6.1)/ ],
	    [ 'Windows 8', /(Windows NT 6.2)/ ],
	    [ 'Windows 8.1', /(Windows NT 6.3)/ ],
	    [ 'Windows 10', /(Windows NT 10.0)/ ],
	    [ 'Windows ME', /Windows ME/ ],
	    [ 'Open BSD', /OpenBSD/ ],
	    [ 'Sun OS', /SunOS/ ],
	    [ 'Linux', /(Linux)|(X11)/ ],
	    [ 'Mac OS', /(Mac_PowerPC)|(Macintosh)/ ],
	    [ 'QNX', /QNX/ ],
	    [ 'BeOS', /BeOS/ ],
	    [ 'OS/2', /OS\/2/ ],
	    [ 'Search Bot', /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/ ]
	  ]);
	}
	
	function buildRules(ruleTuples) {
	  return ruleTuples.map(function(tuple) {
	    return {
	      name: tuple[0],
	      rule: tuple[1]
	    };
	  });
	}
	
	module.exports = {
	  detect: detect,
	  detectOS: detectOS,
	  getNodeVersion: getNodeVersion,
	  parseUserAgent: parseUserAgent
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(157)))

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(164);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(141);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(163);
	
	var _HelmetConstants = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(20);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(144));
	var shallowEqual = _interopDefault(__webpack_require__(167));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 167:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 1689:
/***/ (function(module, exports) {

	exports.endianness = function () { return 'LE' };
	
	exports.hostname = function () {
	    if (typeof location !== 'undefined') {
	        return location.hostname
	    }
	    else return '';
	};
	
	exports.loadavg = function () { return [] };
	
	exports.uptime = function () { return 0 };
	
	exports.freemem = function () {
	    return Number.MAX_VALUE;
	};
	
	exports.totalmem = function () {
	    return Number.MAX_VALUE;
	};
	
	exports.cpus = function () { return [] };
	
	exports.type = function () { return 'Browser' };
	
	exports.release = function () {
	    if (typeof navigator !== 'undefined') {
	        return navigator.appVersion;
	    }
	    return '';
	};
	
	exports.networkInterfaces
	= exports.getNetworkInterfaces
	= function () { return {} };
	
	exports.arch = function () { return 'javascript' };
	
	exports.platform = function () { return 'browser' };
	
	exports.tmpdir = exports.tmpDir = function () {
	    return '/tmp';
	};
	
	exports.EOL = '\n';


/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _oupFullLogoBlueRgb = __webpack_require__(1687);
	
	var _oupFullLogoBlueRgb2 = _interopRequireDefault(_oupFullLogoBlueRgb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OupHeader = function OupHeader(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'oup-header ' + (props.isSticky ? 'oup-header--sticky' : '') },
	    _react2.default.createElement('img', { className: 'oup-header--logo', src: _oupFullLogoBlueRgb2.default, alt: 'Oxford University Press' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'oup-header--controls' },
	      props.children
	    )
	  );
	};
	
	OupHeader.defaultProps = {
	  children: undefined,
	  isSticky: false
	};
	
	OupHeader.propTypes = {
	  children: _propTypes2.default.node,
	  isSticky: _propTypes2.default.bool
	};
	
	exports.default = OupHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 1687:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(162);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(104);
	
	var _detectBrowser = __webpack_require__(909);
	
	var _OupHeader = __webpack_require__(641);
	
	var _OupHeader2 = _interopRequireDefault(_OupHeader);
	
	__webpack_require__(1475);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var browser = (0, _detectBrowser.detect)();
	
	// import createTitle from '../components/createTitle/createTitle';
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children,
	      siteMetadata = _ref.data.site.siteMetadata,
	      pathname = _ref.location.pathname;
	
	  var langKeyPath = siteMetadata.languages.langs.map(function (lang) {
	    return '' + (0, _gatsbyLink.withPrefix)('/') + lang.slug + '/';
	  });
	  var isHomepage = pathname === (0, _gatsbyLink.withPrefix)('/') || langKeyPath.some(function (key) {
	    return key === pathname;
	  });
	  // Check if the user is on IE11 or Edge12-15.
	  // If so we will add a class to .app and serve some different styles.
	  // This is because MS messed up Grid implementation.
	  // It is all nice and fixed in Edge 16.
	  // Annoyingly we can't feature detect on this.
	  // That's because technically these browsers _do_ support grid - just badly.
	  var oldIE = function oldIE() {
	    return browser && (browser.name === 'edge' || browser.name === 'ie') && parseInt(browser.version, 10) < 16;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'app' },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: siteMetadata.title + ' help documents',
	        meta: [{ name: 'description', content: 'Sample' }, { name: 'keywords', content: 'sample, something' }]
	      },
	      _react2.default.createElement('html', { className: '' + (oldIE() ? 'oldIE' : 'modern') })
	    ),
	    children()
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func,
	  data: _propTypes2.default.shape({
	    site: _propTypes2.default.shape({
	      siteMetadata: _propTypes2.default.shape({
	        title: _propTypes2.default.string.isRequired
	      }).isRequired
	    }).isRequired
	  }).isRequired,
	  location: _propTypes2.default.shape({
	    pathname: _propTypes2.default.string.isRequired
	  }).isRequired
	}; // location has other values but they aren't used, so haven't added to PropTypes
	
	exports.default = TemplateWrapper;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 1475:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-908f7fecb7fec09a6b05.js